module.exports = __webpack_public_path__ + "fonts/opensans-semibolditalic-webfont.96c84fe3.ttf";